import { useSelector } from "react-redux";
import { GetTableMapOrderListWithFilters } from "../../../hooks/GetTableMapOrderListWithFilters";
import { OrdersList } from "./components/orders-list"


export const PHUBD_Map = (props, force) => {

            let xxxx = GetTableMapOrderListWithFilters("PickupDelivery")
      const mapRef = useSelector((state) => state.Map.mapRef)

    return <>
            <OrdersList {...props} />
    </>

    
};




